import { FaChevronCircleDown, FaChevronCircleUp } from "react-icons/fa";
import { Post } from "./PostModel";
import { SiSteem } from "react-icons/si";
import { FaHive } from "react-icons/fa";
import { MdPending } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import { IoWarningSharp } from "react-icons/io5";

const SyncStatusIcon = ({ sync_status }: { sync_status: string }) => {
    return (
        <>
            {
                sync_status === "FINISHED" ? (
                    <FaCheckCircle className="text-green-500 w-10" />
                ) : sync_status === "ERROR" ? (
                    <IoWarningSharp className="text-yellow-500 w-10 text-lg" />
                ) : (
                    <MdPending className="text-gray-400 w-10 text-lg" />
                )
            }
        </>
    );
}

function PostingCard({ post }: { post: any }) {
    return (
        <div
            className="flex flex-row bg-gray-700 pl-4 items-center  overflow-hidden rounded-lg my-4 h-16"
        >
            <div className="flex flex-col flex-1 my-2">
                <span className="text-menu">{post.title}</span>

                <div className="flex justify-between">
                    <span className="text-cyan-300">예약 포스팅 날짜 : {post.promise_date}</span>
                    <span className={`text-lime-300 `}>{post.user_name}({post.create_date})</span>
                </div>



            </div>
            <div
                className="flex items-center flex-shrink-0 p-0 m-0 h-full cursor-pointer bg-gray-600 ml-4"
            >
                <div className="flex flex-col gap-2">
                    <SiSteem className="text-blue-500 w-10" />
                    {post.steem_sync_status == 'WAITING'}
                    <SyncStatusIcon sync_status={post.steem_sync_status} />
                </div>
            </div>
            <div
                className="flex items-center flex-shrink-0 p-0 m-0 h-full cursor-pointer bg-gray-900"
            >
                <div className="flex flex-col gap-2">
                    <FaHive className="text-red-500 w-10" />
                    <SyncStatusIcon sync_status={post.hive_sync_status} />
                </div>
            </div>
        </div>
    );

}
// <MdPending className="text-gray-400 w-10 text-lg" />
// <IoWarningSharp className="text-yellow-500 w-10 text-lg" />
export { PostingCard };